const navigation = document.querySelector('.navigation')

if (navigation) {
  const navigationScrollClass = 'navigation--scrolled'

  const checkScroll = () => {
    if (window.scrollY > 100) {
      if (!navigation.classList.contains(navigationScrollClass)) {
        navigation.classList.add(navigationScrollClass)
      }
    } else {
      if (navigation.classList.contains(navigationScrollClass)) {
        navigation.classList.remove(navigationScrollClass)
      }
    }
  }

  document.addEventListener('scroll', () => {
    checkScroll()
  })

  window.addEventListener('DOMContentLoaded', () => {
    checkScroll()
  })
}
